import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const featuredCats = categories.slice(0, 7);

  return (
    <footer className="w-full bg-background-900 text-background-200">
      <div className="max-w-6xl mx-auto px-6 md:px-10 py-14 md:py-18">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-4">
              <span className="font-heading text-xl font-bold text-background-50 tracking-tight">
                oopbuy<span className="text-accent-400">spread</span>
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed mb-5">
              Die größte deutsche OOPBuy Spreadsheet Wissensplattform. Unabhängig, aktuell und sicherheitsorientiert.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-1.5 text-sm text-accent-400 hover:text-accent-300 transition-colors cursor-pointer"
            >
              Zum Spreadsheet
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-xs"></i>
              </span>
            </a>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">Seiten</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/spreadsheet-database" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  Spreadsheet Database
                </Link>
              </li>
              <li>
                <Link to="/oopbuy-sicherheit" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  Sicherheitsguide
                </Link>
              </li>
              <li>
                <Link to="/oopbuy-spreadsheet-guide" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  Kompletter Guide
                </Link>
              </li>
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors">
                  Startseite
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">Beliebte Kategorien</h4>
            <ul className="space-y-2.5">
              {featuredCats.map((cat, i) => (
                <li key={i}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50 mb-4">Wichtige Links</h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-accent-400 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  oopbuy spreadsheet
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-external-link-line text-xs"></i>
                  </span>
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="inline-flex items-center gap-1.5 text-sm font-semibold text-accent-400 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  Buy It Now
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 oopbuyspread.wiki – Unabhängige Informationsplattform. Keine offizielle OOPBuy Website.
          </p>
          <p className="text-xs text-background-500">
            Alle externen Links öffnen in neuem Tab.
          </p>
        </div>
      </div>
    </footer>
  );
}